import qs from 'qs'
import { domainConfigList } from '@/api/treasurebox'
import { useUserInfo } from '@/store'

// 获取域名链接
export const useGetDomain = (noActivity?: boolean) => {
  const userInfo: any = useUserInfo().userInfo
  const { referralCode, channelId } = userInfo || {}
  const domain = ref<string>('')
  const route = useRoute()
  const activityId = route.query.activityId as string | undefined
  // 获取域名
  const queryDomainConfigList = async () => {
    const stringParams: Record<string, string> = {}
    if (referralCode) stringParams['ic'] = referralCode
    if (channelId) stringParams['ch'] = channelId

    if (!noActivity && activityId) {
      stringParams['ai'] = activityId
    }
    try {
      const { code, data } = await domainConfigList({
        type: 'MainDomain',
        jumpType: 'MainDomain',
      })
      if (code !== 1 || data.length === 0) {
        domain.value = `${location.origin}/?${qs.stringify(stringParams)}`
        return
      }
      const domainObj = {
        domain: data[Math.floor(Math.random() * data.length)],
      }
      domain.value = `https://${domainObj.domain}/?${qs.stringify(stringParams)}`
    } catch (error) {
      console.error('Error fetching domain config list:', error)
      domain.value = `${location.origin}/?${qs.stringify(stringParams)}`
    }
  }
  onMounted(() => {
    queryDomainConfigList()
  })

  return { domain }
}
